import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  standalone: false,
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})

export class ContactsComponent implements OnInit {

  langData: any;
  
  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
